const isNonEmptyString = (d: string): boolean => Object.prototype.toString.call(d) === '[object String]' && d.length > 0

const monthMapper = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const transformDate = (timestamp?: string): string => {
  // @ts-ignore: OPERATION BLEED STOPPER
  if (isNonEmptyString(timestamp)) {
    const date = new Date(Number(timestamp))
    const month = monthMapper[date.getMonth()]
    return `${month} ${date.getDate()}, ${date.getFullYear()}`
  }

  return ''
}
